import { RoutesService, eLayoutType } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';
import { APP_INITIALIZER } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routesService: RoutesService) {
  return () => {
    routesService.add([
      {
        path: '/',
        name: '',
        invisible: true,
        layout: eLayoutType.application,
      },
      {
        path: '/access-denied',
        name: '::Menu:AccessDenied',
        invisible: true,
        layout: eLayoutType.application,
      },
      {
        path: '/home',
        name: '::Menu:Home',
        order: 1,
        layout: eLayoutType.application,
      },
      {
        name: '::Menu:Tools',
        layout: eLayoutType.application,
        order: 102,
      },
      {
        path: '/export',
        name: '::Menu:Tools:Export',
        layout: eLayoutType.application,
        parentName: '::Menu:Tools',
      },
      {
        path: `/export-accounting`,
        name: 'GoliathCore::Menu:Tools:AccountingSynchronization',
        layout: eLayoutType.application,
        parentName: '::Menu:Tools',
      },
      {
        path: `/identity/roles`,
        name: 'GoliathCore::Menu:Roles',
        layout: eLayoutType.application,
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'AbpIdentity.Roles',
      },
      {
        path: `/features`,
        name: 'Core::Menu:Features',
        layout: eLayoutType.application,
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'FeatureManagement.ManageHostFeatures',
      },
      {
        path: `/admin/users`,
        name: 'GoliathCore::Menu:Users',
        layout: eLayoutType.application,
        parentName: eThemeSharedRouteNames.Administration,
        requiredPolicy: 'AbpIdentity.Users',
        order: 11,
      },
    ]);
  };
}
